export const PLATFORM = {
  IOS: 2,
  ANDROID: 1,
  MINIPROGRAM: 3,
  PC: 4,
  HARMONYOS: 5
}

export const PLATFORM_LIST = [
  { label: 'IOS', value: 2 },
  { label: '安卓', value: 1 },
  { label: '小程序', value: 3 },
  { label: 'PC', value: 4 },
  { label: '鸿蒙', value: 5 }
]

const callbackvs = [
  ['62', [1, 2, 3, 4, 5, 7]], // 微信mp
  ['16', [1, 2, 3, 4, 5, 7]], // 腾讯广告
  ['207', [1, 2, 4, 5]], // 腾讯小任务
  ['33', [1, 2, 4, 5]], // 爱奇艺
  ['32', [1, 2, 4, 5]], // 快手
  ['17', [1, 4]], // 新浪粉丝通
  ['45', [1, 4, 5]], // 百度
  ['159', [1, 4, 5, 6]], // google
  ['6', [1, 4, 5]], // UC
  ['169', [1]], // 因特云CPA
  ['172', [1, 2, 4, 5]], // sigmob
  ['170', [1]], // 懒鱼cpa
  ['8', [1, 2, 4]], // 网易
  ['173', [1, 2, 4, 5]], // 快接单
  ['59', [1, 2, 4, 5]], // 斗鱼
  ['14', [1, 2, 4]], // 搜狐
  ['104', [1, 2, 4, 5]], // 知乎
  ['112', [1, 2, 4]], // 芒果
  ['109', [1, 2, 4]], // 美图
  ['98', [1]], // 美柚
  ['60', [1, 2, 4, 5]], // 虎牙
  ['10', [1, 2, 4, 5, 8]], // 头条
  ['191', [1, 4, 5]], // 巨量星图
  ['157', [1, 2, 4, 5]], // bilibili
  ['197', [1]], // 优超
  ['130', [1, 2, 4]], // 网易
  ['210', [1, 2, 4, 5, 7]], // 荣耀
  ['213', [1, 2, 4, 5]], // 华为
  ['212', [1]], // 想想ASO
  ['214', [1, 2, 4, 5]], // 华为应用商店
  ['55', [1, 2, 4, 5]], // taptap
  ['215', [1, 2, 4, 5]], // 星广联投（星图）
  ['216', [1, 2, 4, 5]], // 星广联投（AD版）
  ['217', [1]], // 畅玩
  ['218', [1]], // 芈兔兔CPS
  ['219', [1, 2, 4, 5]], // 豆瓣
  ['220', [1, 4, 5]], // 小红书
  ['221', [1, 2, 4, 5]], // 微博
  ['224', [1]] // 微博

]

export const mediaCallbackSettingsInfo = new Map(callbackvs)

export const callbackKeys = [
  'callbackTypeActive',
  'callbackTypeRegist',
  'callbackTypeOrder',
  'callbackTypeRecharge',
  'callbackTypeMoney',
  'callbackTypeRole',
  'callbackTypeRetain',
  'callbackTypeKeyBehavior'
]
